import React from "react";
import {
  WorkflowAppsType,
  WorkflowSuiteApps,
} from "../../../Types/Workflow-Types";
import TextToVideoIcon from "../../../Custom-imeges/VideoSuite/TextToVideoIcon";
import ImageToVideoIcon from "../../../Custom-imeges/VideoSuite/ImageToVideoIcon";
import BlueCheckBoxIcon from "../../../Custom-imeges/BlueCheckBoxIcon";
import { Box } from "@mui/material";
import { Tooltip as MuiTooltip } from "@mui/material";

const WorkflowVideoApps = ({
  apps,
  selectedItemData,
  returnLastSelectedApp,
  handleSetActiveItem,
}: WorkflowSuiteApps) => {
  const WorkflowAppsIcons: Partial<Record<WorkflowAppsType, JSX.Element>> = {
    [WorkflowAppsType.TextToVideo]: <TextToVideoIcon className="custom-icon" />,
    [WorkflowAppsType.ImageToVideo]: (
      <ImageToVideoIcon className="custom-icon" />
    ),
  };
  return (
    <Box className="display-apps mt-2 mb-2">
      {apps?.map((app, i) => {
        const isCompatible =
          !returnLastSelectedApp ||
          app.inputType?.includes(returnLastSelectedApp.outputType||"")
        return (
          <Box
            key={i}
            className={`${
              isCompatible
                ? "active-workflow-app"
                : "inactive-workflow-app"
            }`}
            sx={{ display: "flex", alignItems: "center" }}
            onClick={() => isCompatible && handleSetActiveItem(app)}
          >
            <MuiTooltip
              title="This app’s input type doesn’t match the output of the previous step."
              placement="top"
              arrow
              disableHoverListener={isCompatible}
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "#E5E2E1",
                    color: "#0B1216",
                    fontFamily: "Inter",
                    fontSize: "11px",
                    fontWeight: 500,
                    lineHeight: "17px",
                    maxWidth: "160px",
                    borderRadius: "4px",
                    padding: "8px 12px",
                    gap: "8px",
                  },
                },
                arrow: {
                  sx: {
                    color: "#E5E2E1",
                  },
                },
              }}
            >
              <Box
                className={`text-nav-item workflow-nav-item m-0 ${app.appType?.toLowerCase()} app-workflow-item ${
                  selectedItemData.appType === app.appType && "active"
                }`}
                style={{ textDecoration: "none !important" }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {WorkflowAppsIcons[app.appType as WorkflowAppsType]}
                </Box>
                <span
                  className={`text-nav-item-name ${
                    selectedItemData.appType === app.appType && "active"
                  }`}
                  style={{ textDecoration: "none !important" }}
                >
                  {app.appType}
                  {selectedItemData.appType === app.appType && (
                    <span className="ms-2">
                      <BlueCheckBoxIcon />
                    </span>
                  )}
                </span>
              </Box>
            </MuiTooltip>
          </Box>
        );
      })}
    </Box>
  );
};

export default WorkflowVideoApps;
